import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Route, Switch } from 'react-router'
import SearchResults from './search'
import Explore from '../containers/explore'
import Favorites from '../containers/favorites'
import { capitalize } from 'lodash'
import { removeWords } from 'shared/util/string'
import { Helmet } from 'react-helmet'

// Can be incorporated into other routes
export default props => {
    const IMAGE_TYPES = ['gif', 'gifs', 'sticker', 'stickers']
    const { groupId, search } = props
    let title

    if (groupId === 'favorites') {
        title = `Search, Discover, Share, and Create Animated GIFs | GIPHY`
    } else if (search) {
        if (props.pageType === 'EXPLORE') {
            title = `${capitalize(removeWords(search.term, IMAGE_TYPES))} GIFs - Get the best GIF on GIPHY`
        } else {
            title = `${capitalize(removeWords(search.term, IMAGE_TYPES))} ${search.isSticker
                ? 'Stickers'
                : 'GIFs'} - Find & Share on GIPHY`
        }
    }

    return (
        <div>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <Switch>
                <Route path={'/search'} render={() => <SearchResults {...props} />} />
                <Route path={'/explore'} render={() => <Explore {...props} />} />
                <Route path={'/favorites'} render={() => <Favorites {...props} />} />
            </Switch>
        </div>
    )
}
